import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL_DASH = "https://mis.empowerplus.in";

const METRICS = [
    {
        title: "Organisation-Level Impact Metrics",
        desc: "View overall reach, programme progress, beneficiary profile, geographic coverage, and key outcomes across the organisation.",
        icon: "🏛️",
        gradient: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
        path: "/organisation_impact",
    },
    {
        title: "Youth Skilling",
        desc: "Track mobilisation, enrolment, training completion, certification, placement, salary, and retention outcomes.",
        icon: "🎓",
        gradient: "linear-gradient(135deg, #065f46 0%, #10b981 100%)",
        path: "/youth_skilling",
    },
    {
        title: "Upskilling of Informal Workers",
        desc: "Track training completion, certification, and access to support services.",
        icon: "🔧",
        gradient: "linear-gradient(135deg, #92400e 0%, #f59e0b 100%)",
        path: "/upskilling_informal",
    },
    {
        title: "Women Entrepreneurship Metrics",
        desc: "Track training completion, certification, business plans created, enterprise set-up, and funding support.",
        icon: "👩‍💼",
        gradient: "linear-gradient(135deg, #6b21a8 0%, #d946ef 100%)",
        path: "/women_entrepreneurship",
    },
    {
        title: "Community Development",
        desc: "Track participation across different awareness sessions, enrolment and certification in adult literacy sessions.",
        icon: "🤝",
        gradient: "linear-gradient(135deg, #0e7490 0%, #06b6d4 100%)",
        path: "/community_development",
    },
    {
        title: "Preventive Health",
        desc: "Track health camps, beneficiary footfall, screenings, consultations, identified conditions, referrals, and follow-up support.",
        icon: "🏥",
        gradient: "linear-gradient(135deg, #991b1b 0%, #ef4444 100%)",
        path: "/preventive_health",
    },
    // {
    //     title: "Engagement Metrics",
    //     desc: "Analyse mobilisation activity, beneficiary retention rates, and programme re-engagement trends.",
    //     icon: "📊",
    //     gradient: "linear-gradient(135deg, #3730a3 0%, #6366f1 100%)",
    //     // path: "/candidate_retentions",
    // },
];

export default function HomePage() {
    const navigate = useNavigate();

    const [stats, setStats] = useState([
        { value: "—", label: "Beneficiaries Reached" },
        { value: "—", label: "Training Centres" },
        { value: "—", label: "Active Projects" },
        { value: "—", label: "States Covered" },
    ]);

    useEffect(() => {
        const fmt = (n) => n != null ? Number(n).toLocaleString("en-IN") + "+" : "—";

        const fetchStats = async (token) => {
            const headers = { Authorization: `Bearer ${token}` };
            const [impact, scale, options, counts] = await Promise.all([
                fetch(`${BASE_URL_DASH}/api/view-dashboard/organisation-impact`, { headers })
                    .then(r => r.ok ? r.json() : null).catch(() => null),
                fetch(`${BASE_URL_DASH}/api/view-dashboard/programme-scale`, { headers })
                    .then(r => r.ok ? r.json() : null).catch(() => null),
                fetch(`${BASE_URL_DASH}/api/view-dashboard/filter-options`, { headers })
                    .then(r => r.ok ? r.json() : null).catch(() => null),
                fetch(`${BASE_URL_DASH}/api/dashboard/counts`, { headers })
                    .then(r => r.ok ? r.json() : null).catch(() => null),
            ]);

            if (!impact && !scale && !options && !counts) return;

            const centerCount = options && Array.isArray(options.centers) ? options.centers.length : null;
            const newStats = [
                {
                    value: impact?.totalCandidates != null
                        ? fmt(impact.totalCandidates)
                        : fmt(counts?.candidates ?? counts?.mobilizations),
                    label: "Beneficiaries Reached",
                },
                {
                    value: centerCount != null ? fmt(centerCount) : fmt(counts?.centers),
                    label: "Training Centres",
                },
                {
                    value: scale?.totalProjects != null
                        ? fmt(scale.totalProjects)
                        : fmt(counts?.projects),
                    label: "Total Projects",
                },
                {
                    value: "13",
                    label: "States Covered",
                },
            ];
            setStats(newStats);
        };

        const run = async () => {
            let token = localStorage.getItem("token");

            if (!token) {
                try {
                    const res = await fetch(`${BASE_URL_DASH}/api/auth/login`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ email: "admin@gmail.com", password: "Admin@123" }),
                    });
                    if (res.ok) {
                        const data = await res.json();
                        token = data.token;
                        if (token) sessionStorage.setItem("viewer_token", token);
                    }
                } catch { }
            }

            if (token) await fetchStats(token);
        };

        run();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("viewer_token");
        navigate("/impacthub_login", { replace: true });
    };

    return (
        <div className="hp-root">

            {/* ── VIEWER TOPBAR ── */}
            <div style={{
                display: "flex", justifyContent: "flex-end", alignItems: "center",
                padding: "10px 24px", background: "#0f172a", borderBottom: "1px solid #1e293b"
            }}>
                <span style={{ color: "#94a3b8", fontSize: 12, marginRight: 12 }}>Impact Dashboard</span>
                <button
                    onClick={handleLogout}
                    style={{
                        background: "transparent", border: "1px solid #374151",
                        color: "#94a3b8", padding: "5px 14px", borderRadius: 8,
                        fontSize: 12, fontWeight: 700, cursor: "pointer",
                    }}
                >
                    Logout
                </button>
            </div>

            {/* ── NAV ── */}
            {/* <nav className="hp-nav">
                <div className="hp-nav-inner">
                    <div className="hp-brand">
                        <img src="/images/logo.png" alt="Logo" className="hp-logo"
                            onError={(e) => { e.target.style.display = "none"; }} />
                        <span className="hp-brand-name">EmpowerPlus MIS</span>
                    </div>
                    <button className="hp-nav-btn" onClick={() => navigate("/login")}>
                        Login →
                    </button>
                </div>
            </nav> */}

            {/* ── HERO ── */}
            <section className="hp-hero">
                <div className="hp-hero-inner">

                    {/* LEFT — About */}
                    <div className="hp-about">
                        <div className="hp-tag">Management Information System</div>
                        <h1 className="hp-h1">
                            Empower <br />
                            <span className="hp-h1-accent">ImpactHub</span>
                        </h1>
                        <p className="hp-desc">
                            Empower ImpactHub is a unified platform for tracking programme reach, progress, and outcomes across all Government, CSR funded, Foreign funded projects since inception.
                        </p>

                        {/* Stats row */}
                        <div className="hp-stats">
                            {stats.map((s) => (
                                <div key={s.label} className="hp-stat">
                                    <div className="hp-stat-val">{s.value}</div>
                                    <div className="hp-stat-lbl">{s.label}</div>
                                </div>
                            ))}
                        </div>

                        <div className="hp-cta-row">
                            {/* <button className="hp-btn-primary" onClick={() => navigate("/login")}>
                                Get Started
                            </button> */}
                            <button className="hp-btn-ghost" onClick={() => navigate("/login")}>
                                View Dashboard →
                            </button>
                        </div>
                    </div>

                    {/* RIGHT — Snapshot */}
                    <div className="hp-snapshot-wrap">
                        <div className="hp-snapshot-frame">
                            <div className="hp-snapshot-bar">
                                <span className="dot red" /><span className="dot yellow" /><span className="dot green" />
                                <span className="hp-snapshot-url">mis.empowerplus.in/dashboard</span>
                            </div>
                            <div className="hp-snapshot-body">
                                <img
                                    src="/images/dashboard-1.png"
                                    alt="Dashboard Preview"
                                    className="hp-snapshot-img"
                                    onError={(e) => {
                                        e.target.style.display = "none";
                                        e.target.parentElement.classList.add("no-img");
                                    }}
                                />
                                {/* Fallback mock dashboard */}
                                {/* <div className="hp-mock-dash">
                                    <div className="mock-row">
                                        <div className="mock-card blue"><div className="mock-num">12,480</div><div className="mock-lbl">Enrolled</div></div>
                                        <div className="mock-card green"><div className="mock-num">9,312</div><div className="mock-lbl">Completed</div></div>
                                        <div className="mock-card purple"><div className="mock-num">6,204</div><div className="mock-lbl">Placed</div></div>
                                        <div className="mock-card orange"><div className="mock-num">74%</div><div className="mock-lbl">Placement Rate</div></div>
                                    </div>
                                    <div className="mock-chart">
                                        <div className="mock-bar-group">
                                            {[65, 80, 55, 90, 70, 85, 60].map((h, i) => (
                                                <div key={i} className="mock-bar" style={{ height: `${h}%` }} />
                                            ))}
                                        </div>
                                        <div className="mock-chart-lbl">Monthly Enrolment Trend</div>
                                    </div>
                                    <div className="mock-table-header">
                                        <span>Centre ID</span><span>State</span><span>Enrolled</span><span>Status</span>
                                    </div>
                                    {["EP/TC-A001 · Maharashtra · 320 · Active",
                                        "EP/TC-A002 · Gujarat · 218 · Active",
                                        "EP/TC-A003 · Rajasthan · 145 · Active"].map((row, i) => {
                                            const [id, state, count, status] = row.split(" · ");
                                            return (
                                                <div key={i} className="mock-table-row">
                                                    <span>{id}</span><span>{state}</span><span>{count}</span>
                                                    <span className="mock-badge">{status}</span>
                                                </div>
                                            );
                                        })}
                                </div> */}
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* ── METRICS CARDS ── */}
            <section className="hp-cards-section">
                <div className="hp-cards-inner">
                    {/* <div className="hp-section-hd">
                        <h2 className="hp-section-title">Empower ImpactHub</h2>
                        <p className="hp-section-sub">
                            Empower ImpactHub is a unified platform for tracking programme reach, progress, and
                            outcomes across all Government, CSR funded, Foreign funded projects since inception.
                        </p>
                    </div> */}

                    <div className="hp-cards-grid">
                        {METRICS.map((m) => (
                            <div
                                key={m.title}
                                className="hp-card"
                                onClick={() => navigate(m.path)}
                            >
                                <div className="hp-card-icon-wrap" style={{ background: m.gradient }}>
                                    <span className="hp-card-icon">{m.icon}</span>
                                </div>
                                <div className="hp-card-body">
                                    <h3 className="hp-card-title">{m.title}</h3>
                                    <p className="hp-card-desc">{m.desc}</p>
                                </div>
                                <div className="hp-card-arrow" style={{ background: m.gradient }}>→</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── FOOTER ── */}
            <footer className="hp-footer">
                <div className="hp-footer-inner">
                    <span>© 2026 EmpowerPlus MIS. All rights reserved.</span>
                    <span style={{ color: "#6b7280" }}>Built for social impact at scale.</span>
                </div>
            </footer>

            <style>{`
* { box-sizing: border-box; margin: 0; padding: 0; }

.hp-root {
    min-height: 100vh;
    background: #f8fafc;
    font-family: Inter, system-ui, -apple-system, sans-serif;
    color: #111827;
}

/* ── NAV ── */
.hp-nav {
    position: sticky; top: 0; z-index: 100;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid #e5e7eb;
}
.hp-nav-inner {
    max-width: 1280px; margin: 0 auto;
    padding: 14px 32px;
    display: flex; align-items: center; justify-content: space-between;
}
.hp-brand { display: flex; align-items: center; gap: 10px; }
.hp-logo { height: 36px; width: auto; }
.hp-brand-name { font-size: 18px; font-weight: 900; color: #1e3a8a; letter-spacing: -0.3px; }
.hp-nav-btn {
    background: #1e3a8a; color: #fff;
    border: none; padding: 9px 22px; border-radius: 10px;
    font-weight: 800; font-size: 14px; cursor: pointer;
    transition: background 0.15s;
}
.hp-nav-btn:hover { background: #1e40af; }

/* ── HERO ── */
.hp-hero {
    background: linear-gradient(135deg, #eff6ff 0%, #f0fdf4 50%, #fdf4ff 100%);
    padding: 32px 32px 36px;
    border-bottom: 1px solid #e5e7eb;
}
.hp-hero-inner {
    max-width: 1280px; margin: 0 auto;
    display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center;
}
@media (max-width: 900px) {
    .hp-hero-inner { grid-template-columns: 1fr; }
    .hp-snapshot-wrap { display: none; }
}

/* LEFT */
.hp-tag {
    display: inline-block;
    background: #dbeafe; color: #1d4ed8;
    font-size: 11px; font-weight: 800; letter-spacing: 0.8px;
    text-transform: uppercase; padding: 4px 10px; border-radius: 999px;
    margin-bottom: 10px;
}
.hp-h1 {
    font-size: clamp(22px, 3vw, 34px);
    font-weight: 900; line-height: 1.15;
    letter-spacing: -0.5px; margin-bottom: 10px; color: #0f172a;
}
.hp-h1-accent {
    background: linear-gradient(90deg, #2563eb, #7c3aed);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
}
.hp-desc {
    font-size: 13px; line-height: 1.6; color: #475569; margin-bottom: 16px; max-width: 520px;
}

.hp-stats {
    display: grid; grid-template-columns: repeat(4, 1fr);
    gap: 8px; margin-bottom: 16px;
}
@media (max-width: 600px) { .hp-stats { grid-template-columns: repeat(2, 1fr); } }

.hp-stat {
    background: #fff; border: 1px solid #e5e7eb;
    border-radius: 10px; padding: 8px 8px; text-align: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.hp-stat-val { font-size: 16px; font-weight: 900; color: #1e3a8a; }
.hp-stat-lbl { font-size: 10px; color: #6b7280; font-weight: 700; margin-top: 2px; }

.hp-cta-row { display: flex; gap: 10px; flex-wrap: wrap; }
.hp-btn-primary {
    background: linear-gradient(135deg, #1e3a8a, #2563eb);
    color: #fff; border: none; padding: 9px 20px;
    border-radius: 10px; font-weight: 800; font-size: 13px; cursor: pointer;
    box-shadow: 0 4px 14px rgba(37,99,235,0.35);
    transition: transform 0.15s, box-shadow 0.15s;
}
.hp-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(37,99,235,0.45); }
.hp-btn-ghost {
    background: transparent; color: #1e3a8a;
    border: 2px solid #bfdbfe; padding: 7px 18px;
    border-radius: 10px; font-weight: 800; font-size: 13px; cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
}
.hp-btn-ghost:hover { border-color: #2563eb; background: #eff6ff; }

/* RIGHT — Snapshot */
.hp-snapshot-wrap { perspective: 1200px; }
.hp-snapshot-frame {
    background: #fff;
    border-radius: 12px; overflow: hidden;
    box-shadow: 0 16px 40px rgba(0,0,0,0.13), 0 3px 8px rgba(0,0,0,0.07);
    transform: rotateY(-4deg) rotateX(2deg);
    transition: transform 0.3s;
}
.hp-snapshot-frame:hover { transform: rotateY(0deg) rotateX(0deg); }
.hp-snapshot-bar {
    background: #f1f5f9; padding: 7px 12px;
    display: flex; align-items: center; gap: 5px;
    border-bottom: 1px solid #e5e7eb;
}
.dot { width: 8px; height: 8px; border-radius: 50%; }
.dot.red { background: #ef4444; }
.dot.yellow { background: #f59e0b; }
.dot.green { background: #10b981; }
.hp-snapshot-url {
    margin-left: 8px; flex: 1; background: #fff;
    border: 1px solid #e5e7eb; border-radius: 5px;
    padding: 3px 8px; font-size: 10px; color: #6b7280;
}
.hp-snapshot-body { position: relative; min-height: 220px; }
.hp-snapshot-img { width: 100%; display: block; }

/* Mock dashboard (fallback) */
.hp-mock-dash { padding: 10px; background: #f8fafc; }
.mock-row { display: grid; grid-template-columns: repeat(4,1fr); gap: 6px; margin-bottom: 8px; }
.mock-card { border-radius: 8px; padding: 7px; text-align: center; color: #fff; }
.mock-card.blue { background: linear-gradient(135deg,#1e40af,#3b82f6); }
.mock-card.green { background: linear-gradient(135deg,#065f46,#10b981); }
.mock-card.purple { background: linear-gradient(135deg,#4c1d95,#8b5cf6); }
.mock-card.orange { background: linear-gradient(135deg,#92400e,#f59e0b); }
.mock-num { font-size: 12px; font-weight: 900; }
.mock-lbl { font-size: 8px; font-weight: 700; opacity: 0.85; margin-top: 1px; }

.mock-chart {
    background: #fff; border: 1px solid #e5e7eb; border-radius: 8px;
    padding: 8px; margin-bottom: 8px;
}
.mock-bar-group { display: flex; align-items: flex-end; gap: 4px; height: 55px; }
.mock-bar {
    flex: 1; background: linear-gradient(to top, #2563eb, #93c5fd);
    border-radius: 4px 4px 0 0; min-height: 20%;
}
.mock-chart-lbl { font-size: 10px; color: #6b7280; font-weight: 700; margin-top: 8px; text-align: center; }

.mock-table-header {
    display: grid; grid-template-columns: 2fr 1.5fr 1fr 1fr;
    padding: 6px 8px; background: #f1f5f9; border-radius: 6px;
    font-size: 10px; font-weight: 800; color: #6b7280; margin-bottom: 4px;
}
.mock-table-row {
    display: grid; grid-template-columns: 2fr 1.5fr 1fr 1fr;
    padding: 6px 8px; border-bottom: 1px solid #f1f5f9; font-size: 10px; color: #374151;
}
.mock-badge {
    background: #dcfce7; color: #166534;
    font-size: 9px; font-weight: 800; padding: 2px 6px; border-radius: 999px;
    display: inline-block; width: fit-content;
}

/* ── CARDS SECTION ── */
.hp-cards-section { padding: 40px 32px; background: #fff; }
.hp-cards-inner { max-width: 1280px; margin: 0 auto; }
.hp-section-hd { text-align: center; margin-bottom: 28px; }
.hp-section-title { font-size: 24px; font-weight: 900; color: #0f172a; letter-spacing: -0.3px; }
.hp-section-sub { font-size: 13px; color: #64748b; margin-top: 6px; }

.hp-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
}

.hp-card {
    background: #fff; border: 1px solid #e5e7eb; border-radius: 18px;
    padding: 24px; display: flex; align-items: flex-start; gap: 18px;
    cursor: pointer; position: relative; overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
}
.hp-card::before {
    content: ""; position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(37,99,235,0.03), transparent);
    opacity: 0; transition: opacity 0.2s;
}
.hp-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0,0,0,0.12);
    border-color: #bfdbfe;
}
.hp-card:hover::before { opacity: 1; }

.hp-card-icon-wrap {
    width: 52px; height: 52px; border-radius: 14px;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0; box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}
.hp-card-icon { font-size: 24px; }

.hp-card-body { flex: 1; }
.hp-card-title { font-size: 15px; font-weight: 900; color: #0f172a; margin-bottom: 6px; line-height: 1.3; }
.hp-card-desc { font-size: 13px; color: #6b7280; line-height: 1.6; }

.hp-card-arrow {
    width: 30px; height: 30px; border-radius: 8px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 14px; font-weight: 900; align-self: center;
    opacity: 0; transition: opacity 0.2s; margin-left: auto;
}
.hp-card:hover .hp-card-arrow { opacity: 1; }

/* ── FOOTER ── */
.hp-footer {
    background: #0f172a; padding: 24px 32px;
}
.hp-footer-inner {
    max-width: 1280px; margin: 0 auto;
    display: flex; justify-content: space-between; align-items: center;
    font-size: 13px; color: #94a3b8; flex-wrap: wrap; gap: 8px;
}
            `}</style>
        </div>
    );
}



// import React from "react";
// import { useNavigate } from "react-router-dom";

// const METRICS = [
//     {
//         title: "Organisation-Level Impact Metrics",
//         desc: "View overall reach, programme progress, beneficiary profile, geographic coverage, and key outcomes across the organisation.",
//         icon: "🏛️",
//         gradient: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
//         path: "/organisation_impact",
//     },
//     {
//         title: "Youth Skilling",
//         desc: "Track mobilisation, enrolment, training completion, certification, placement, salary, and retention outcomes.",
//         icon: "🎓",
//         gradient: "linear-gradient(135deg, #065f46 0%, #10b981 100%)",
//         path: "/youth_skilling",
//     },
//     {
//         title: "Upskilling of Informal Workers",
//         desc: "Track training completion, certification, and access to support services.",
//         icon: "🔧",
//         gradient: "linear-gradient(135deg, #92400e 0%, #f59e0b 100%)",
//         path: "/upskilling_informal",
//     },
//     {
//         title: "Women Entrepreneurship Metrics",
//         desc: "Track training completion, certification, business plans created, enterprise set-up, and funding support.",
//         icon: "👩‍💼",
//         gradient: "linear-gradient(135deg, #6b21a8 0%, #d946ef 100%)",
//         path: "/women_entrepreneurship",
//     },
//     {
//         title: "Community Development",
//         desc: "Track participation across different awareness sessions, enrolment and certification in adult literacy sessions.",
//         icon: "🤝",
//         gradient: "linear-gradient(135deg, #0e7490 0%, #06b6d4 100%)",
//         path: "/community_development",
//     },
//     {
//         title: "Preventive Health",
//         desc: "Track health camps, beneficiary footfall, screenings, consultations, identified conditions, referrals, and follow-up support.",
//         icon: "🏥",
//         gradient: "linear-gradient(135deg, #991b1b 0%, #ef4444 100%)",
//         path: "/preventive_health",
//     },
//     // {
//     //     title: "Engagement Metrics",
//     //     desc: "Analyse mobilisation activity, beneficiary retention rates, and programme re-engagement trends.",
//     //     icon: "📊",
//     //     gradient: "linear-gradient(135deg, #3730a3 0%, #6366f1 100%)",
//     //     // path: "/candidate_retentions",
//     // },
// ];

// const STATS = [
//     { value: "50,000+", label: "Beneficiaries Reached" },
//     { value: "120+", label: "Training Centres" },
//     { value: "35+", label: "Active Projects" },
//     { value: "18", label: "States Covered" },
// ];

// export default function HomePage() {
//     const navigate = useNavigate();

//     return (
//         <div className="hp-root">

//             {/* ── NAV ── */}
//             {/* <nav className="hp-nav">
//                 <div className="hp-nav-inner">
//                     <div className="hp-brand">
//                         <img src="/images/logo.png" alt="Logo" className="hp-logo"
//                             onError={(e) => { e.target.style.display = "none"; }} />
//                         <span className="hp-brand-name">EmpowerPlus MIS</span>
//                     </div>
//                     <button className="hp-nav-btn" onClick={() => navigate("/login")}>
//                         Login →
//                     </button>
//                 </div>
//             </nav> */}

//             {/* ── HERO ── */}
//             <section className="hp-hero">
//                 <div className="hp-hero-inner">

//                     {/* LEFT — About */}
//                     <div className="hp-about">
//                         <div className="hp-tag">Management Information System</div>
//                         <h1 className="hp-h1">
//                             Empower <br />
//                             <span className="hp-h1-accent">ImpactHub</span>
//                         </h1>
//                         <p className="hp-desc">
//                             Empower ImpactHub is a unified platform for tracking programme reach, progress, and outcomes across all Government, CSR funded, Foreign funded projects since inception.
//                         </p>

//                         {/* Stats row */}
//                         <div className="hp-stats">
//                             {STATS.map((s) => (
//                                 <div key={s.label} className="hp-stat">
//                                     <div className="hp-stat-val">{s.value}</div>
//                                     <div className="hp-stat-lbl">{s.label}</div>
//                                 </div>
//                             ))}
//                         </div>

//                         <div className="hp-cta-row">
//                             {/* <button className="hp-btn-primary" onClick={() => navigate("/login")}>
//                                 Get Started
//                             </button> */}
//                             <button className="hp-btn-ghost" onClick={() => navigate("/login")}>
//                                 View Dashboard →
//                             </button>
//                         </div>
//                     </div>

//                     {/* RIGHT — Snapshot */}
//                     <div className="hp-snapshot-wrap">
//                         <div className="hp-snapshot-frame">
//                             <div className="hp-snapshot-bar">
//                                 <span className="dot red" /><span className="dot yellow" /><span className="dot green" />
//                                 <span className="hp-snapshot-url">mis.empowerplus.in/dashboard</span>
//                             </div>
//                             <div className="hp-snapshot-body">
//                                 <img
//                                     src="/images/dashboard-1.png"
//                                     alt="Dashboard Preview"
//                                     className="hp-snapshot-img"
//                                     onError={(e) => {
//                                         e.target.style.display = "none";
//                                         e.target.parentElement.classList.add("no-img");
//                                     }}
//                                 />
//                                 {/* Fallback mock dashboard */}
//                                 {/* <div className="hp-mock-dash">
//                                     <div className="mock-row">
//                                         <div className="mock-card blue"><div className="mock-num">12,480</div><div className="mock-lbl">Enrolled</div></div>
//                                         <div className="mock-card green"><div className="mock-num">9,312</div><div className="mock-lbl">Completed</div></div>
//                                         <div className="mock-card purple"><div className="mock-num">6,204</div><div className="mock-lbl">Placed</div></div>
//                                         <div className="mock-card orange"><div className="mock-num">74%</div><div className="mock-lbl">Placement Rate</div></div>
//                                     </div>
//                                     <div className="mock-chart">
//                                         <div className="mock-bar-group">
//                                             {[65, 80, 55, 90, 70, 85, 60].map((h, i) => (
//                                                 <div key={i} className="mock-bar" style={{ height: `${h}%` }} />
//                                             ))}
//                                         </div>
//                                         <div className="mock-chart-lbl">Monthly Enrolment Trend</div>
//                                     </div>
//                                     <div className="mock-table-header">
//                                         <span>Centre ID</span><span>State</span><span>Enrolled</span><span>Status</span>
//                                     </div>
//                                     {["EP/TC-A001 · Maharashtra · 320 · Active",
//                                         "EP/TC-A002 · Gujarat · 218 · Active",
//                                         "EP/TC-A003 · Rajasthan · 145 · Active"].map((row, i) => {
//                                             const [id, state, count, status] = row.split(" · ");
//                                             return (
//                                                 <div key={i} className="mock-table-row">
//                                                     <span>{id}</span><span>{state}</span><span>{count}</span>
//                                                     <span className="mock-badge">{status}</span>
//                                                 </div>
//                                             );
//                                         })}
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </section>

//             {/* ── METRICS CARDS ── */}
//             <section className="hp-cards-section">
//                 <div className="hp-cards-inner">
//                     {/* <div className="hp-section-hd">
//                         <h2 className="hp-section-title">Empower ImpactHub</h2>
//                         <p className="hp-section-sub">
//                             Empower ImpactHub is a unified platform for tracking programme reach, progress, and
//                             outcomes across all Government, CSR funded, Foreign funded projects since inception.
//                         </p>
//                     </div> */}

//                     <div className="hp-cards-grid">
//                         {METRICS.map((m) => (
//                             <div
//                                 key={m.title}
//                                 className="hp-card"
//                                 onClick={() => navigate(m.path)}
//                             >
//                                 <div className="hp-card-icon-wrap" style={{ background: m.gradient }}>
//                                     <span className="hp-card-icon">{m.icon}</span>
//                                 </div>
//                                 <div className="hp-card-body">
//                                     <h3 className="hp-card-title">{m.title}</h3>
//                                     <p className="hp-card-desc">{m.desc}</p>
//                                 </div>
//                                 <div className="hp-card-arrow" style={{ background: m.gradient }}>→</div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </section>

//             {/* ── FOOTER ── */}
//             <footer className="hp-footer">
//                 <div className="hp-footer-inner">
//                     <span>© 2026 EmpowerPlus MIS. All rights reserved.</span>
//                     <span style={{ color: "#6b7280" }}>Built for social impact at scale.</span>
//                 </div>
//             </footer>

//             <style>{`
// * { box-sizing: border-box; margin: 0; padding: 0; }

// .hp-root {
//     min-height: 100vh;
//     background: #f8fafc;
//     font-family: Inter, system-ui, -apple-system, sans-serif;
//     color: #111827;
// }

// /* ── NAV ── */
// .hp-nav {
//     position: sticky; top: 0; z-index: 100;
//     background: rgba(255,255,255,0.92);
//     backdrop-filter: blur(12px);
//     border-bottom: 1px solid #e5e7eb;
// }
// .hp-nav-inner {
//     max-width: 1280px; margin: 0 auto;
//     padding: 14px 32px;
//     display: flex; align-items: center; justify-content: space-between;
// }
// .hp-brand { display: flex; align-items: center; gap: 10px; }
// .hp-logo { height: 36px; width: auto; }
// .hp-brand-name { font-size: 18px; font-weight: 900; color: #1e3a8a; letter-spacing: -0.3px; }
// .hp-nav-btn {
//     background: #1e3a8a; color: #fff;
//     border: none; padding: 9px 22px; border-radius: 10px;
//     font-weight: 800; font-size: 14px; cursor: pointer;
//     transition: background 0.15s;
// }
// .hp-nav-btn:hover { background: #1e40af; }

// /* ── HERO ── */
// .hp-hero {
//     background: linear-gradient(135deg, #eff6ff 0%, #f0fdf4 50%, #fdf4ff 100%);
//     padding: 32px 32px 36px;
//     border-bottom: 1px solid #e5e7eb;
// }
// .hp-hero-inner {
//     max-width: 1280px; margin: 0 auto;
//     display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center;
// }
// @media (max-width: 900px) {
//     .hp-hero-inner { grid-template-columns: 1fr; }
//     .hp-snapshot-wrap { display: none; }
// }

// /* LEFT */
// .hp-tag {
//     display: inline-block;
//     background: #dbeafe; color: #1d4ed8;
//     font-size: 11px; font-weight: 800; letter-spacing: 0.8px;
//     text-transform: uppercase; padding: 4px 10px; border-radius: 999px;
//     margin-bottom: 10px;
// }
// .hp-h1 {
//     font-size: clamp(22px, 3vw, 34px);
//     font-weight: 900; line-height: 1.15;
//     letter-spacing: -0.5px; margin-bottom: 10px; color: #0f172a;
// }
// .hp-h1-accent {
//     background: linear-gradient(90deg, #2563eb, #7c3aed);
//     -webkit-background-clip: text; -webkit-text-fill-color: transparent;
// }
// .hp-desc {
//     font-size: 13px; line-height: 1.6; color: #475569; margin-bottom: 16px; max-width: 520px;
// }

// .hp-stats {
//     display: grid; grid-template-columns: repeat(4, 1fr);
//     gap: 8px; margin-bottom: 16px;
// }
// @media (max-width: 600px) { .hp-stats { grid-template-columns: repeat(2, 1fr); } }

// .hp-stat {
//     background: #fff; border: 1px solid #e5e7eb;
//     border-radius: 10px; padding: 8px 8px; text-align: center;
//     box-shadow: 0 1px 4px rgba(0,0,0,0.05);
// }
// .hp-stat-val { font-size: 16px; font-weight: 900; color: #1e3a8a; }
// .hp-stat-lbl { font-size: 10px; color: #6b7280; font-weight: 700; margin-top: 2px; }

// .hp-cta-row { display: flex; gap: 10px; flex-wrap: wrap; }
// .hp-btn-primary {
//     background: linear-gradient(135deg, #1e3a8a, #2563eb);
//     color: #fff; border: none; padding: 9px 20px;
//     border-radius: 10px; font-weight: 800; font-size: 13px; cursor: pointer;
//     box-shadow: 0 4px 14px rgba(37,99,235,0.35);
//     transition: transform 0.15s, box-shadow 0.15s;
// }
// .hp-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(37,99,235,0.45); }
// .hp-btn-ghost {
//     background: transparent; color: #1e3a8a;
//     border: 2px solid #bfdbfe; padding: 7px 18px;
//     border-radius: 10px; font-weight: 800; font-size: 13px; cursor: pointer;
//     transition: border-color 0.15s, background 0.15s;
// }
// .hp-btn-ghost:hover { border-color: #2563eb; background: #eff6ff; }

// /* RIGHT — Snapshot */
// .hp-snapshot-wrap { perspective: 1200px; }
// .hp-snapshot-frame {
//     background: #fff;
//     border-radius: 12px; overflow: hidden;
//     box-shadow: 0 16px 40px rgba(0,0,0,0.13), 0 3px 8px rgba(0,0,0,0.07);
//     transform: rotateY(-4deg) rotateX(2deg);
//     transition: transform 0.3s;
// }
// .hp-snapshot-frame:hover { transform: rotateY(0deg) rotateX(0deg); }
// .hp-snapshot-bar {
//     background: #f1f5f9; padding: 7px 12px;
//     display: flex; align-items: center; gap: 5px;
//     border-bottom: 1px solid #e5e7eb;
// }
// .dot { width: 8px; height: 8px; border-radius: 50%; }
// .dot.red { background: #ef4444; }
// .dot.yellow { background: #f59e0b; }
// .dot.green { background: #10b981; }
// .hp-snapshot-url {
//     margin-left: 8px; flex: 1; background: #fff;
//     border: 1px solid #e5e7eb; border-radius: 5px;
//     padding: 3px 8px; font-size: 10px; color: #6b7280;
// }
// .hp-snapshot-body { position: relative; min-height: 220px; }
// .hp-snapshot-img { width: 100%; display: block; }

// /* Mock dashboard (fallback) */
// .hp-mock-dash { padding: 10px; background: #f8fafc; }
// .mock-row { display: grid; grid-template-columns: repeat(4,1fr); gap: 6px; margin-bottom: 8px; }
// .mock-card { border-radius: 8px; padding: 7px; text-align: center; color: #fff; }
// .mock-card.blue { background: linear-gradient(135deg,#1e40af,#3b82f6); }
// .mock-card.green { background: linear-gradient(135deg,#065f46,#10b981); }
// .mock-card.purple { background: linear-gradient(135deg,#4c1d95,#8b5cf6); }
// .mock-card.orange { background: linear-gradient(135deg,#92400e,#f59e0b); }
// .mock-num { font-size: 12px; font-weight: 900; }
// .mock-lbl { font-size: 8px; font-weight: 700; opacity: 0.85; margin-top: 1px; }

// .mock-chart {
//     background: #fff; border: 1px solid #e5e7eb; border-radius: 8px;
//     padding: 8px; margin-bottom: 8px;
// }
// .mock-bar-group { display: flex; align-items: flex-end; gap: 4px; height: 55px; }
// .mock-bar {
//     flex: 1; background: linear-gradient(to top, #2563eb, #93c5fd);
//     border-radius: 4px 4px 0 0; min-height: 20%;
// }
// .mock-chart-lbl { font-size: 10px; color: #6b7280; font-weight: 700; margin-top: 8px; text-align: center; }

// .mock-table-header {
//     display: grid; grid-template-columns: 2fr 1.5fr 1fr 1fr;
//     padding: 6px 8px; background: #f1f5f9; border-radius: 6px;
//     font-size: 10px; font-weight: 800; color: #6b7280; margin-bottom: 4px;
// }
// .mock-table-row {
//     display: grid; grid-template-columns: 2fr 1.5fr 1fr 1fr;
//     padding: 6px 8px; border-bottom: 1px solid #f1f5f9; font-size: 10px; color: #374151;
// }
// .mock-badge {
//     background: #dcfce7; color: #166534;
//     font-size: 9px; font-weight: 800; padding: 2px 6px; border-radius: 999px;
//     display: inline-block; width: fit-content;
// }

// /* ── CARDS SECTION ── */
// .hp-cards-section { padding: 40px 32px; background: #fff; }
// .hp-cards-inner { max-width: 1280px; margin: 0 auto; }
// .hp-section-hd { text-align: center; margin-bottom: 28px; }
// .hp-section-title { font-size: 24px; font-weight: 900; color: #0f172a; letter-spacing: -0.3px; }
// .hp-section-sub { font-size: 13px; color: #64748b; margin-top: 6px; }

// .hp-cards-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
//     gap: 20px;
// }

// .hp-card {
//     background: #fff; border: 1px solid #e5e7eb; border-radius: 18px;
//     padding: 24px; display: flex; align-items: flex-start; gap: 18px;
//     cursor: pointer; position: relative; overflow: hidden;
//     transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
// }
// .hp-card::before {
//     content: ""; position: absolute; inset: 0;
//     background: linear-gradient(135deg, rgba(37,99,235,0.03), transparent);
//     opacity: 0; transition: opacity 0.2s;
// }
// .hp-card:hover {
//     transform: translateY(-4px);
//     box-shadow: 0 12px 40px rgba(0,0,0,0.12);
//     border-color: #bfdbfe;
// }
// .hp-card:hover::before { opacity: 1; }

// .hp-card-icon-wrap {
//     width: 52px; height: 52px; border-radius: 14px;
//     display: flex; align-items: center; justify-content: center;
//     flex-shrink: 0; box-shadow: 0 4px 12px rgba(0,0,0,0.2);
// }
// .hp-card-icon { font-size: 24px; }

// .hp-card-body { flex: 1; }
// .hp-card-title { font-size: 15px; font-weight: 900; color: #0f172a; margin-bottom: 6px; line-height: 1.3; }
// .hp-card-desc { font-size: 13px; color: #6b7280; line-height: 1.6; }

// .hp-card-arrow {
//     width: 30px; height: 30px; border-radius: 8px; flex-shrink: 0;
//     display: flex; align-items: center; justify-content: center;
//     color: #fff; font-size: 14px; font-weight: 900; align-self: center;
//     opacity: 0; transition: opacity 0.2s; margin-left: auto;
// }
// .hp-card:hover .hp-card-arrow { opacity: 1; }

// /* ── FOOTER ── */
// .hp-footer {
//     background: #0f172a; padding: 24px 32px;
// }
// .hp-footer-inner {
//     max-width: 1280px; margin: 0 auto;
//     display: flex; justify-content: space-between; align-items: center;
//     font-size: 13px; color: #94a3b8; flex-wrap: wrap; gap: 8px;
// }
//             `}</style>
//         </div>
//     );
// }
